// =============================================================================
//  Copyright   : 2023 semantics GmbH
//  Date        : $Date: 2023-05-24 09:12:28 +0200 (Wed, 24 May 2023) $
//  Author      : Dirk Rothe
//  Worker      : $Author: a.hesse $
//  Revision    : $Rev: 134866 $
//  Purpose     : sagas for vlm package
// =============================================================================
// ---Third-party imports
import {takeEvery} from 'redux-saga/effects'

// ---Framework imports
import log from 'uix/logging'

export const sagas = {
  setVlmState: takeEvery('SET_TO_VLM_STATE', function*({payload}) {
    let {name, value} = payload
    //log.x(name, value)
    globalThis.vlmhost?.tovlm(name, value)
  }),
}
